import { useBoolean } from "hooks";
import { Modal, Progress } from "ui";

import { useTopSellingCategories } from "../../api";
import { StatisticsBlockLayout } from "../../layouts";

import styles from "./TopSellingCategories.module.scss";

const TopSellingCategories = () => {
  const { categories } = useTopSellingCategories();
  const {
    value: isAllCategoriesOpen,
    setTrue: openAllCategories,
    setFalse: closeAllCategories
  } = useBoolean(false);

  return (
    <StatisticsBlockLayout
      title="Top-Selling Categories"
      titleAdditional="by sold products"
      onShowAll={openAllCategories}
    >
      <div className={styles.categories__statistics}>
        {categories?.slice(0, 6).map((category) => (
          <Progress
            key={category.id}
            title={category.name}
            subTitle={category.mostSoldSubcategory}
            amount={category.productsSold}
            percentage={category.percentageOfProductsSold}
          />
        ))}
      </div>

      <Modal
        isOpen={isAllCategoriesOpen}
        onClose={closeAllCategories}
        title="All Top-Selling Categories"
        contentClassName={styles.categories__modal}
        footer={<></>}
      >
        <div className={styles.categories__statistics}>
          {categories?.map((category) => (
            <Progress
              key={category.id}
              title={category.name}
              subTitle={category.mostSoldSubcategory}
              amount={category.productsSold}
              percentage={category.percentageOfProductsSold}
            />
          ))}
        </div>
      </Modal>
    </StatisticsBlockLayout>
  );
};

export default TopSellingCategories;
